import {animate, animateChild, group, query, style, transition, trigger} from '@angular/animations';

export const slider =
  trigger('routeAnimations', [
    // tslint:disable-next-line:max-line-length
    transition('1 => 2,1 => 3,1 => 4,1 => 5,1 => 6,1 => 7,1 => 8,2 => 3,2 => 4, 2 => 5,2 => 6,2 => 7,2 => 8,3 => 4,3 => 5,3 => 6,3 => 7,3 => 8, 4 => 5,4 => 6,4 => 7,4 => 8,5 => 6,5 => 7,5 => 8,6 => 7,7 => 8, 1 => 9,2 => 9,3 => 9,4 => 9,5 => 9,6 => 9,7 => 9, 8 => 9, 1 => 10,2 => 10,3 => 10,4 => 10,5 => 10,6 => 10,7 => 10, 8 => 10, 9 => 10, 10 => 9', [
      query(':enter, :leave', [
        style({
          position: 'fixed',
          top: 0,
          right: 0,
          width: '100%',
          height: '100%',
          boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
        })
      ], { optional: true }),
      query(':enter', [
        style({ right: '-100%'}),
      ]),
      group([
        query(':leave', [
          animate('700ms ease', style({ right: '100%'}))
        ], { optional: true }),
        query(':enter', [
          animate('700ms ease', style({ right: '0%'}))
        ])
      ]),
      // Normalize the page style... Might not be necessary
      // Required only if you have child animations on the page
      query(':leave', animateChild()),
      query(':enter', animateChild()),
    ]),
    // tslint:disable-next-line:max-line-length
    transition('8 => 7,8 => 6,8 => 5,8 => 4,8 => 3,8 => 2,8 => 1,7 => 6,7 => 5,7 => 4,7 => 3,7 => 2,7 => 1,6 => 5,6 => 4,6 => 3,6 => 2,6 => 1,5 => 4,5 => 3,5 => 2,5 => 1,4 => 3,4 => 2,4 => 1,3 => 2,3 => 1,2 => 1,9 => 1,9 => 2,9 => 3,9 => 4,9 => 5,9 => 6,9 => 7, 9 => 8, 10 => 8,10 => 7,10 => 6,10 => 5,10 => 4,10 => 3,10 => 2, 10 => 1', [
      query(':enter, :leave', [
        style({
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
        })
      ], { optional: true }),
      query(':enter', [
        style({ left: '-100%'})
      ]),
      group([
        query(':leave', [
          animate('700ms ease', style({ left: '100%'}))
        ], { optional: true }),
        query(':enter', [
          animate('700ms ease', style({ left: '0%'}))
        ])
      ]),
      // Normalize the page style... Might not be necessary
      // Required only if you have child animations on the page
      query(':leave', animateChild()),
      query(':enter', animateChild()),
    ]),
  ]);

